<style lang="less" scoped src="../css/common.less"></style>
<style lang="less" scoped>
    .content {
        margin-top: 20px;
        .sub-item-container {
            padding: 10px 10px 10px 71px;
        }
    }
    .sub-item-image{
        width: 50px;
        height: 50px;
        img {
            vertical-align: middle;
            max-width: 100%;
            max-height: 100%;
        }
    }
    .image-normal{
        display: inline-block;
        vertical-align: top;
        margin-right: 5px;
    }



    .linestyle{
      font-size:12px;
      font-family:SourceHanSansSC-Regular,SourceHanSansSC;
      font-weight:400;
      color:rgb(1, 5, 19);;
    }

    .card-content{
      padding: 10px;
      margin-right: 10px;
      margin-bottom: 0px;
      border-bottom: 0px;
      text-align: left;
    }

    .card{
      padding: 10px;
      margin-right: 10px;
      margin-bottom: 10px;
      border: 1px solid #dddee1;
      text-align: left;
    }

    .card-title1{
      width:64px;
      height:22px;
      font-size:14px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(0,0,0,0.85);
      line-height:30px;
    }

</style>
<template>
    <div class="wrap" style="width: 700px">
        <h2 class="text-center">线下发货批量申请详情</h2>
        <div class="content" v-if="offline_order_batch_detail.id">

          <div class="card-content">
            <div>
              <span class="card-title1">
                  申请基本信息
              </span>
              <div>
                <Row class="line">
                  <i-col span = "12">
                    <span class="linestyle">填写人:</span><span>{{offline_order_batch_detail.upload_user_name || '  -'}}</span>
                  </i-col>
                  <i-col span = "12">
                    <span class="linestyle">申请人:</span><span>{{offline_order_batch_detail.apply_user_name || '  -'}}</span>
                  </i-col>
                </Row>
                <Row>
                  <i-col span = "12">
                    <span class="linestyle">申请项目组:</span><span>{{offline_order_batch_detail.channel_name}}</span>
                  </i-col>
                  <i-col span = "12">
                    <span class="linestyle">申请商品总数:</span><span>{{offline_order_batch_detail.all_item_count || '  -'}}</span>
                  </i-col>
                </Row>
                <Row class="line">
                  <i-col span = "12">
                    <span class="linestyle">申请商品价值(元):</span><span>{{offline_order_batch_detail.all_item_price/100 || '  -'}}</span>
                  </i-col>
                  <i-col span = "12">
                    <span class="linestyle">申请时间:</span><span>{{offline_order_batch_detail.create_at || '  -'}}</span>
                  </i-col>
                </Row>
                <Row>
                  <i-col span="12">
                    <div class="linestyle">商品列表：</div>
                  </i-col>
                </Row>
                <Row>
                  <i-col span="2"/>
                  <Table
                      :columns="sub_sku_columns"
                      :data= offline_order_batch_detail.sku_summary
                      size="small"
                      border
                  />
                </Row>
              </div>
            </div>
          </div>

          <div class="card-content" v-if="offline_order_batch_detail.id">
            <span class="card-title1">
                发货单列表
            </span>
            <Table :columns="offline_order_column" :data="offline_order_data" size="small" max-height="500" width="600" border></Table>
          </div>

          <div v-show="page_info.total">
            <Page
                show-total
                show-elevator
                :current="page_info.current"
                :total="page_info.total"
                :page-size="page_info.page_size"
                @on-change="pageChange">
            </Page>
          </div>

          <div class="card-content" v-if="offline_order_batch_detail.user_flow">
            <span class="card-title1">
                流程状态
            </span>
            <div class="value">
              <UserFlow :user_flow="offline_order_batch_detail.user_flow"></UserFlow>
            </div>
          </div>

        </div>

    </div>
</template>
<script>
    import UserFlowBase from '../../../../views/components/flow/user_flow_base';
    import Util from '../../../../libs/util'
    import UserFlow from '../../../components/flow/user_flow'
    import OfflineOrderDetail from "@/views/offline/order/offline_order_detail";
    export default {
        components: { UserFlowBase,UserFlow },
        props: {
            model_id: {
                type: Number,
            },
            type: {
              type: String
            },
            tip: {
              type: Boolean,
              default: true
            }
        },
        data(){
            return {
              util: Util,
              params: {
                per_page: 10,
                page: 1,
                id: ''
              },
              page_info: {
                current: 1,
                total: 0,
                page_size: 10
              },
              offline_order_batch_detail_path: Util.api.offline_order_batch_detail_path,
              offline_order_batch_detail:'',
              offline_order_data:[],
              sub_sku_columns:[
                {
                  title: '存货编码',
                  key: 'code',
                  width: 80,
                },
                {
                  title: '商品简称',
                  key: 'name',
                  width: 200,
                },
                {
                  title: '单品用量',
                  key: 'count'
                },
              ],
              offline_order_column:[
                {
                  title: '发货单号',
                  align: 'center',
                  fixed: 'left',
                  key: 'id'
                },
                {
                  title: '用途',
                  align: 'center',
                  key: 'usage',
                  render: (h, params)=>{
                    let usage = params.row.usage
                    return h('span', this.util.offlineOrderSendUsage(usage));
                  }
                },
                {
                  title: '状态',
                  align: 'center',
                  key: 'status',
                  render: (h, params)=>{
                    let status = params.row.status;
                    if(status == 0 ){
                      return h('span', '已填写');
                    }else if(status == 1){
                      return h('span', '审核中');
                    }else if(status == 2){
                      return h('span', '待确认');
                    }else if(status == 3){
                      return h('span', '已确认');
                    }else if(status == 4){
                      return h('span', '已发货');
                    }else if(status == 5){
                      return h('span', '已签收');
                    }else if(status == 6){
                      return h('span', '已完成');
                    }
                  }
                },
                {
                  title: '店铺',
                  align: 'center',
                  key: 'shop',
                  render: (h, params)=>{
                    let shop = params.row.shop
                    return h('span', this.util.offlineOrderSendShop(shop));
                  }
                },
                {
                  title: '项目组',
                  align: 'center',
                  key: 'channel_name'
                },
                {
                  title: '申请人',
                  align: 'center',
                  key: 'apply_user_name'
                },
                {
                  title: '总价(元)',
                  align: 'center',
                  key: 'item_cost',
                  render: (h, params)=>{
                    let item_cost = params.row.item_cost
                    // if(item_cost){
                    //   return h('span', item_cost/100);
                    // } else {
                    //   return h('span', 0);
                    // }
                    return h('span', '**');
                  }
                },
                {
                  title: '收货人',
                  align: 'center',
                  key: 'recv_user'
                },
                {
                  title: '详情',
                  align: 'center',
                  fixed: 'right',
                  width: 50,
                  render: (h, params) => {
                    const row = params.row;
                    return h(OfflineOrderDetail, {
                      props: {
                        type: 'OfflineOrderDetail',
                        model_id: row.id,
                        tip: false
                      },
                      'class': {
                        link: true
                      }
                    }, '查看');
                  }
                }
              ]
            }
        },
        computed: {

        },
        created(){
          this.getOfflineOrderBatchDetail();
        },
        mounted(){

        },
        methods: {
          getOfflineOrderBatchDetail(){
              if(!this.loading){
                this.loading = true;
                this.params.id = this.model_id
                Util.ajax.get(this.offline_order_batch_detail_path, {params: this.params}).then((response) => {
                  return response.data;
                }).then((res) => {
                  if(res.code === 1){
                    this.offline_order_batch_detail = res.data.offline_order_batch_details
                    this.offline_order_data = res.data.offline_order_batch_details.offline_orders
                    this.page_info.total = res.data.total_count
                  }else{
                    this.$Modal.error({
                      title: '错误',
                      content: res.msg
                    });
                  }
                }).catch((e) => {
                  this.loading = false;
                  this.empty_tip = '获取数据失败, 请刷新页面重试';
                  console.log(e);
                });
              }
            },
          pageChange(new_page){
            this.loading = false;
            this.params.page = new_page;
            this.getOfflineOrderBatchDetail();
          },
        }
    }
</script>
